
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { AuthMyfileService } from "src/app/core/services/auth.myfile.service";
import { GlobalComponent } from "src/app/global-component";
import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { SortByValuesModel } from "src/app/core/models/table/sort-by-values.model";
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { DocumentStatus } from "src/app/core/models/document/document-template-model";

export class EmailTemplateListConfig extends TableConfigurationModel {

    constructor() {
        super();
        this.canConfigBeSavedToServer = true;
        this.listTitle = "Email Templates List";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: GlobalComponent.defaultPagingInfo.pageSizeLG },
            { pageSize: GlobalComponent.defaultPagingInfo.pageSizeXL },
            { pageSize: GlobalComponent.defaultPagingInfo.exportPageSize },
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },

            {
                dataFieldName: 'emailSubject',
                title: 'Subject',
                sortable: new SortByValuesModel(),
                visible: 'true',
                order: 1,
                width: "250px",
                type: ColumnTypeEnum.String,
            },

            {
                dataFieldName: 'name',
                title: 'Name',
                sortable: new SortByValuesModel(),
                visible: 'true',
                order: 2,
                width: "250px",
                type: ColumnTypeEnum.String,
            },
            {
                dataFieldName: 'senderName',
                title: 'Sender Name',
                sortable: new SortByValuesModel(),
                visible: 'true',
                order: 3,
                width: "250px",
                type: ColumnTypeEnum.String,
            },
            {
                dataFieldName: 'senderEmail',
                title: 'Sender Email',
                sortable: new SortByValuesModel(),
                visible: 'true',
                order: 4,
                width: "250px",
                type: ColumnTypeEnum.String,
            },
            {
                title: 'Actions',
                visible: 'true',
                order: 5,
                width: "125px",
                type: ColumnTypeEnum.Action
            },
        ]
        this.searchbarFilter =
        {
            value: '',
            placeHolderText: "Search by name"
        }

        this.filters = [

        ]

        this.actions = [
            {
                visible: 'true',
                label: 'Edit',
                actionId: ActionIdEnum.Edit,
                icon: 'ri-edit-line',
                inDropdown: true,
                inList: true
            },
        ]

        this.buttons = [
            {
                visible: 'true',
                label: "Create New",
                iconIsAfterLabel: false,
                action: ButtonIdEnum.CreateNew,
                color: "btn-success",
                icon: "ri-add-fill",
                type: ButtonTypeEnum.Default
            },
            {
                visible: 'true',
                label: "Export",
                action: ButtonIdEnum.None,
                color: "btn-soft-info",
                iconIsAfterLabel: true,
                icon: "ri-more-2-fill",
                type: ButtonTypeEnum.Dropdown,
                actions: [
                    {
                        text: $localize`:@@Export_Excel:Export to Excel`,
                        value: `${ButtonIdEnum.ExportExcel}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    },
                    {
                        text: $localize`:@@Export_CSV:Export to CSV`,
                        value: `${ButtonIdEnum.ExportCSV}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    }
                ]
            },

        ]
    }
}